module.exports = __webpack_public_path__ + "static/img/cq_qushi.6a8ec94f.png";